import config from '../config'
import { authorizedFetch } from '../utils/auth'
import { checkStatus } from '../utils/fetch'
import { logout } from './auth'
import moment from 'moment'

export const FETCH_LOCATIONS = 'FETCH_LOCATIONS'
export const UPDATE_LOCATION = 'UPDATE_LOCATION'
export const SHOW_LOCATION_DETAILS = 'SHOW_LOCATION_DETAILS'
export const HIDE_LOCATIONS_DETAILS = 'HIDE_LOCATIONS_DETAILS'
export const RECEIVED_LOCATIONS = 'RECEIVED_LOCATIONS'
export const HANDLE_DATE_CHANGE = 'HANDLE_DATE_CHANGE'
export const HANDLE_DETAILS_DATE_CHANGE = 'HANDLE_DETAILS_DATE_CHANGE'
export const UPDATE_DATE_FOCUS = 'UPDATE_DATE_FOCUS'
export const BOOK_TIMESLOT = 'BOOK_TIMESLOT'
export const UNBOOK_TIMESLOT = 'UNBOOK_TIMESLOT'
export const SELECT_TIMESLOT = 'SELECT_TIMESLOT'
export const SHOW_BOOKING_INVITATION_MODAL = 'SHOW_BOOKING_INVITATION_MODAL'
export const CLOSE_BOOKING_INVITATION_MODAL = 'CLOSE_BOOKING_INVITATION_MODAL'
export const RECEIVED_OPTIONS = 'RECEIVED_OPTIONS'
export const ADD_INVITEE = 'ADD_INVITEE'
export const REMOVE_INVITEE = 'REMOVE_INVITEE'
export const UPDATE_BOOKING = 'UPDATE_BOOKING'
export const SET_INVITEE_EMAIL = 'SET_INVITEE_EMAIL'
export const SHOW_USER = 'SHOW_USER'
export const REQUEST_COMPANIES = 'REQUEST_COMPANIES'
export const RECEIVED_COMPANIES = 'RECEIVED_COMPANIES'
export const RECEIVED_USERS = 'RECEIVED_USERS'
export const SHOW_SEARCH = 'SHOW_SEARCH'
export const SHOW_INVITATIONS_LIST = 'SHOW_INVITATIONS_LIST'
export const ACTIVATE_USER_SUCCESS = 'ACTIVATE_USER_SUCCESS'
export const SET_USER_IN_SEARCH = 'SET_USER_IN_SEARCH'
export const SET_COMPANY_IN_SEARCH = 'SET_COMPANY_IN_SEARCH'
export const SHOW_SWITCH = 'SHOW_SWITCH'
export const HIDE_SWITCH = 'HIDE_SWITCH'
export const SWITCH_COMPANY_CHANGE = 'SWITCH_COMPANY_CHANGE'
export const SWITCH_BUILDING_CHANGE = 'SWITCH_BUILDING_CHANGE'
export const ON_TYPE_SEARCH = 'ON_TYPE_SEARCH'

export const showBookingInvitationModal = () => ({
  type: SHOW_BOOKING_INVITATION_MODAL
})

export const closeBookingInvitationModal = () => ({
  type: CLOSE_BOOKING_INVITATION_MODAL
})

export const fetchLocationDetails = locationId => dispatch => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'locations/details/' + locationId, {
    headers: headers,
    cache: 'default',
    method: 'GET'
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => dispatch(updateLocation(response)))
    .catch(function(error) {
      dispatch(logout())
    })
}

export const fetchSearchInvitee = (email, buildingId, companyId) => dispatch => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'locations/checkAccount/', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({
      email: email,
      company_id: companyId,
      building_id: buildingId
    })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(receivedMatchingOptions(json)))
    .catch(function(error) {
      dispatch(logout())
    })
}

export const receivedMatchingOptions = options => ({
  type: RECEIVED_OPTIONS,
  options: options
})

export const addInvitee = (emailOrInvitation, bookingId) => dispatch => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'locations/addInvitee/', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ email: emailOrInvitation, booking_id: bookingId })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(updateBooking(json)))
    .catch(function(error) {
      dispatch(logout())
    })
}

export const removeInvitee = (user, booking) => dispatch => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'locations/removeInvitee/', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ user_id: user._id, booking_id: booking._id })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(updateBooking(json)))
    .catch(function(error) {
      dispatch(logout())
    })
}

export const updateBooking = booking => ({
  type: UPDATE_BOOKING,
  booking: booking
})

export const setInviteeEmail = email => ({
  type: SET_INVITEE_EMAIL,
  inviteeEmail: email
})

export const fetchLocations = userId => dispatch => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'locations/list/' + userId, {
    headers: headers,
    cache: 'default',
    method: 'GET'
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(receivedLocations(json)))
    .catch(function(error) {
      dispatch(logout())
    })
}

export const fetchCompanies = () => dispatch => {
  dispatch(requestCompanies())
  authorizedFetch(config.api_url + 'companies/list')
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(receivedCompanies({ data: json })))
    .catch(function(error) {
      dispatch(logout())
    })
}

export const fetchUsersForCompany = (building_id, user_id) => dispatch => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  const route = `${config.api_url}buildings/users/${building_id}`
  authorizedFetch(route, {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ user_id })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(receivedUsers(json)))
    .catch(function(error) {
      dispatch(logout())
    })
}

export const requestCompanies = () => ({
  type: REQUEST_COMPANIES
})

export const receivedCompanies = json => ({
  type: RECEIVED_COMPANIES,
  json: json.data
})

export const updateLocation = location => ({
  type: UPDATE_LOCATION,
  location: location
})

export const hideLocationDetails = () => ({
  type: HIDE_LOCATIONS_DETAILS
})

export const showLocationDetails = location => ({
  type: SHOW_LOCATION_DETAILS,
  location: location
})

export const receivedLocations = locations => ({
  type: RECEIVED_LOCATIONS,
  locations: locations
})

export const receivedUsers = users => ({
  type: RECEIVED_USERS,
  users: users
})

export const handleDateChange = date => ({
  filterDate: date,
  type: HANDLE_DATE_CHANGE
})

export const handleDetailsDateChange = date => ({
  filterDate: date,
  type: HANDLE_DETAILS_DATE_CHANGE
})

export const updateDateFocus = (focused, detailFocused) => ({
  focused: focused,
  detailFocused: detailFocused,
  type: UPDATE_DATE_FOCUS
})

export const bookTimeslot = (timeslot, location, account) => dispatch => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  let startDate = moment(timeslot.startDate).format('YYYY-MM-DD HH:mm:ss.SSSZ')
  let endDate = moment(timeslot.startDate)
    .add({ minutes: timeslot.duration })
    .format('YYYY-MM-DD HH:mm:ss.SSSZ')

  authorizedFetch(config.api_url + 'locations/book/', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({
      platform: 'web',
      author: account.fullName,
      location_id: location._id,
      start_date: startDate,
      end_date: endDate,
      user_id: account._id
    })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => dispatch(updateLocation(response.location)))
    .then(response => dispatch(selectTimeslot(timeslot)))
    .catch(function(error) {
      dispatch(logout())
    })
}

export const unbookTimeslot = (timeslot, location, account, userId) => dispatch => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  let startDate = moment(timeslot.startDate).format('YYYY-MM-DD HH:mm:ss.SSSZ')
  let endDate = moment(timeslot.startDate)
    .add({ minutes: timeslot.duration })
    .format('YYYY-MM-DD HH:mm:ss.SSSZ')

  authorizedFetch(config.api_url + 'locations/unbook/', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({
      platform: 'web',
      author: account.fullName,
      location_id: location._id,
      start_date: startDate,
      end_date: endDate,
      account_id: account._id,
      user_id: userId
    })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => dispatch(updateLocation(response.location)))
    .then(response => dispatch(selectTimeslot(undefined)))
    .catch(function(error) {
      dispatch(logout())
    })
}

export const linkBookings = (booking1, booking2) => dispatch => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'locations/link/', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({
      booking_id: booking1._id,
      second_booking_id: booking2._id
    })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => dispatch(updateLocation(response.location)))
    .catch(function(error) {
      dispatch(logout())
    })
}

export const unlinkBookings = (booking, startDate, endDate) => dispatch => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  let start = moment(startDate).format('YYYY-MM-DD HH:mm:ss.SSSZ')
  let end = moment(endDate).format('YYYY-MM-DD HH:mm:ss.SSSZ')

  authorizedFetch(config.api_url + 'locations/unlink/', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({
      booking_id: booking._id,
      start_date: start,
      end_date: end
    })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => dispatch(updateLocation(response.location)))
    .catch(function(error) {
      dispatch(logout())
    })
}

export const selectTimeslot = timeslot => ({
  timeslot: timeslot,
  type: SELECT_TIMESLOT
})
export const showSearch = () => ({
  type: SHOW_SEARCH
})

export const showInvitationsList = () => ({
  type: SHOW_INVITATIONS_LIST
})

export const activateUser = buildingId => dispatch => {
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + '/users/:building_id', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ building_id: buildingId })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(activateUserByBuildingSuccess(json)))
    .catch(function(error) {
      dispatch(logout())
    })
}

export const activateUserByBuildingSuccess = user => ({
  type: ACTIVATE_USER_SUCCESS,
  user: user
})

export const setUserInSearch = selectedUser => ({
  type: SET_USER_IN_SEARCH,
  selectedUser
})

export const setCompanyInSearch = companies => ({
  type: SET_COMPANY_IN_SEARCH,
  companies
})

export const showSwitch = () => ({
  type: SHOW_SWITCH
})

export const hideSwitch = () => ({
  type: HIDE_SWITCH
})

export const SwitchCompanyChange = () => ({
  type: SWITCH_COMPANY_CHANGE
})

export const SwitchBuildingChange = checkedByBuilding => ({
  type: SWITCH_BUILDING_CHANGE,
  checkedByBuilding
})

export const onTypeSearch = typedText => ({
  type: ON_TYPE_SEARCH,
  typedText
})



// WEBPACK FOOTER //
// ./src/actions/locations.js